import type { ReactElement, ReactNode } from 'react'
import { cn } from '../../lib/cn'

export interface EmptyStateProps {
  /** One line stating what will appear here. Not "No data". */
  title: string
  description?: ReactNode
  /** One primary action, named for its outcome. */
  action?: ReactNode
  className?: string
  compact?: boolean
  surface?: 'paper' | 'chrome'
}

/**
 * The state of a surface that has nothing in it yet. No illustration, no shrug —
 * a sentence and a way forward.
 */
export const EmptyState = ({
  title,
  description,
  action,
  className,
  compact = false,
  surface = 'paper',
}: EmptyStateProps): ReactElement => (
  <div
    className={cn(
      'flex flex-col items-center justify-center text-center',
      compact ? 'gap-2 py-6' : 'gap-3 py-12',
      className,
    )}
  >
    <p className={cn('t-h3', surface === 'chrome' ? 'text-chrome-ink' : 'text-ink')}>{title}</p>
    {description ? (
      <p
        className={cn(
          't-small max-w-md',
          surface === 'chrome' ? 'text-chrome-mute' : 'text-ink-mute',
        )}
      >
        {description}
      </p>
    ) : null}
    {action ? <div className="mt-1">{action}</div> : null}
  </div>
)
